import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import EducationContainer from './EducationContainer';

const EducationContainerEditConfig = {
  emptyLabel: 'Education Container',

  isEmpty: function(props: any): boolean {
    return !props;
  },
};

class EducationContainerWrapper extends Component {
  props: any;

  render(): JSX.Element {
    return <EducationContainer {...this.props} />;
  }
}

export default MapTo('workplace-spa/components/educationcontainer')(
  EducationContainerWrapper,
  EducationContainerEditConfig,
);
